module.exports = __webpack_public_path__ + "img/yangtongtong.2c2a4cea.png";